module.exports = __webpack_public_path__ + "img/three-iphones@3x.48a52db9.png";